import { Component, ElementRef, Inject, Renderer } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { tokenNotExpired } from 'angular2-jwt';
import { MainService } from 'app/services';
import { MyCookieService } from 'app/services/my-cookie.service';
import { environment } from 'environments/environment';
import { DialogInfoAbbilitazioneCookieComponent } from '../utilita/dialogs/dialog-info-abbilitazione-cookie/dialog-info-abbilitazione-cookie.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent 
{
  showIscrizione: boolean = true;

  constructor(private mainService: MainService,
    private el: ElementRef, private renderer: Renderer,
    @Inject(MyCookieService) private cookieService: MyCookieService,
    private dialog: MatDialog, private router: Router) 
  {
    // in produzione l'iscrizione dell'utente è disabilitata in questo momento
    if(environment.production && !environment.test_env){
      this.showIscrizione = false;
    }
  }

  onMenuClick() 
  {
      this.renderer.setElementClass(this.el.nativeElement.querySelector('#navbar-brand-centered'), 'in', false);        
    }

  logout(): boolean {
    this.mainService.authService.logout();
    this.router.navigate(['/']);
    return false;
  }

  onAnchorClick ( ) {
    if(this.router.url.startsWith('/login')){
      this.router.navigate(['/'],{ fragment: 'iscrizione'});
    }
    const element = document.querySelector ( "#iscrizione" )
    if ( element ){ 
      element.scrollIntoView ( true );
      window.scroll(0, window.scrollY- 75);
    }
  }

  accedi(menu: boolean) {
    if(!this.cookieService.token)
    {
      this.dialog.open(DialogInfoAbbilitazioneCookieComponent);
    }
    if(menu)
    {
      this.renderer.setElementClass(this.el.nativeElement.querySelector('#navbar-brand-centered'), 'in', false);
    }
    return false;
  }

  loggedIn() { 
    const token = localStorage.getItem(environment.tokenName);
    if(token != undefined){
      if(tokenNotExpired(environment.tokenName)){
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  partnerRoute(){
    if(this.router.url.startsWith('/')){
      this.router.navigate(['/'],{ fragment: 'partner'});
    }
    const element = document.querySelector ( "#partner" )
    if ( element ){ 
      element.scrollIntoView ( true );
      window.scroll(0, window.scrollY- 75);
    }
}


}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/menu/menu.component.ts